/**
 * One place that knows what each audit is called and what it looks like.
 *
 * There were two audits and four components, and each of them carried its own
 * pair of icon imports, its own pair of label keys and, in two places, a ternary
 * that quietly rendered anything unrecognised as the first audit. Adding a third
 * meant editing all four and hoping none was missed.
 *
 * Now the components walk `AUDIT_KINDS` and ask here. A fourth audit needs a row
 * in this table and two strings in each catalogue, and nothing else on this
 * screen changes.
 */
import { Radar, Search, ShieldCheck, type LucideIcon } from "lucide-react";
import type { AuditKind } from "../../../lib/siteAudits";

export interface AuditKindMeta {
  /** Column header, tile label and history row label. */
  labelKey: string;
  /** KPI tile above the table. */
  totalKey: string;
  /** "This domain has not had that audit" filter chip. */
  missingKey: string;
  icon: LucideIcon;
}

export const AUDIT_KIND_META: Record<AuditKind, AuditKindMeta> = {
  aeo: {
    labelKey: "siteAudits.col.agentAudit",
    totalKey: "siteAudits.kpi.aeo",
    missingKey: "siteAudits.coverage.missingAeo",
    icon: Radar,
  },
  seo: {
    labelKey: "siteAudits.col.seoAudit",
    totalKey: "siteAudits.kpi.seo",
    missingKey: "siteAudits.coverage.missingSeo",
    icon: Search,
  },
  gdpr: {
    labelKey: "siteAudits.col.gdprAudit",
    totalKey: "siteAudits.kpi.gdpr",
    missingKey: "siteAudits.coverage.missingGdpr",
    icon: ShieldCheck,
  },
};
